/* eslint-disable react-hooks/exhaustive-deps */
/**
 *
 * Profile
 *
 */
import { AppWrapper } from 'core/layouts/AppWrapper';
import React, { memo, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CreateUpdateDetails } from './CreateUpdateDetails';
import { useUserSetupSlice } from 'features/UserSetup/slice';
import { RootState } from 'controller/types';
import { useDispatch, useSelector } from 'react-redux';

interface Props { }

export const checkParamsCount = searchParams => {
    if (searchParams) {
        let count = 0;
        searchParams.forEach((value, key) => {
            count += 1;
        });
        return count > 0;
    }
    return false;
};

export const modules = [
    { name: 'Profile', url: 'userDetail' },
    { name: 'Change Password', url: 'updatePassword' },
    { name: 'Signed-in Devices', url: 'sessions' },
];

export const UserProfileSettings = memo((props: Props) => {

    const dispatch = useDispatch();
    const { actions } = useUserSetupSlice();
    const state = useSelector((state: RootState) => state.userSetup);
    const [searchParams, setSearchParams] = useSearchParams();
    const [key, setKey] = useState<number>(0);

    useEffect(() => {
        if (searchParams) {
            let count = 0;
            searchParams.forEach((value, key) => {
                count += 1;
            });

            if (!count) {
                searchParams.set('module', '0');
                searchParams.set('action', 'list');
                setSearchParams(searchParams);
            } else {
                setKey(parseInt(searchParams.get('module') as string));
            }
        }
    }, [searchParams, setSearchParams]);

    useEffect(() => {
        dispatch(actions.clearUserData());
    }, []);

    React.useEffect(() => {
        if (state && state?.navigate && searchParams) {
            searchParams.set('action', 'list');
            searchParams.delete('id');
            setSearchParams(searchParams);
            dispatch(actions.setNavigate(false));
        }
    }, [state, searchParams, setSearchParams, dispatch, actions]);


    return (
        <>
            <div className="w-full h-[92%] py-[1%] grid grid-cols-11 gap-[2%]">
                <div
                    className="col-span-2 flex justify-center"
                    onMouseEnter={() => {
                        searchParams.delete('__save_success');
                        searchParams.delete('__delete_success');
                        setSearchParams(searchParams);
                    }}
                >
                    <div className="cursor-pointer ml-[4%] w-[100%] h-max bg-white rounded-xl p-[6%]">
                        <div className="font-bold text-xl mb-3  text-primary-main">
                            Account
                        </div>
                        {modules.map((item, index) => (
                            <div
                                className={`${index !== key && 'hover:bg-primary-10'
                                    } w-full pl-[5%] pr-[4%] py-[6%] border-l-2 ${index === key
                                        ? 'border-l-primary-main'
                                        : 'border-l-neutral-30'
                                    } ${index === key && 'font-semibold'
                                    } rounded-tr-md rounded-br-md cursor-pointer text-[0.95rem]`}
                                onClick={() => {
                                    if (index === key) {
                                        return;
                                    }
                                    searchParams.set('module', index.toString());
                                    setSearchParams(searchParams);
                                    setKey(index);
                                    dispatch(actions.clearUserData());
                                }}
                            >
                                {item.name}
                            </div>
                        ))}
                    </div>
                </div>
               <div className="col-span-9 mb-7">
                    {searchParams &&
                        state &&
                        checkParamsCount(searchParams) &&
                        (searchParams.get('action') === 'list' ? (
                            <CreateUpdateDetails
                                moduleKey={key}
                                moduleName={
                                    modules[parseInt(searchParams.get('module') as string)].name
                                }
                            />
                        ) : <></>)}
                </div>
            </div>
        </>
    );
});
